/**
 * After a successful logistics RFQ POST, we store id + reference so "View RFQ" can open the read-only page.
 * Reference acts as a secret for anonymous GET /submission/:id
 */
export function saveLogisticsRfqSubmissionMeta(companyId, { id, rfqReferenceNumber, rfqKind }) {
  if (id == null || rfqReferenceNumber == null || String(rfqReferenceNumber).trim() === '') return;
  const meta = {
    id: Number(id),
    rfqReferenceNumber: String(rfqReferenceNumber).trim(),
    rfqKind: rfqKind || 'generic',
  };
  if (!Number.isFinite(meta.id) || meta.id <= 0) return;
  try {
    if (companyId != null && Number(companyId) > 0) {
      sessionStorage.setItem(`lgrq-submission-${Number(companyId)}`, JSON.stringify(meta));
    }
    sessionStorage.setItem(
      'lgrq-last-submission',
      JSON.stringify({
        ...meta,
        logisticsProviderCompanyId: companyId != null && Number(companyId) > 0 ? Number(companyId) : null,
      })
    );
  } catch {
    /* ignore */
  }
}

export function getSubmissionMetaForProvider(companyId) {
  const cid = Number(companyId);
  try {
    const per = sessionStorage.getItem(`lgrq-submission-${cid}`);
    if (per) {
      const j = JSON.parse(per);
      if (j?.id && j?.rfqReferenceNumber) return j;
    }
    const last = sessionStorage.getItem('lgrq-last-submission');
    if (last) {
      const j = JSON.parse(last);
      if (j?.id && j?.rfqReferenceNumber) {
        const lp = j.logisticsProviderCompanyId != null ? Number(j.logisticsProviderCompanyId) : null;
        if (lp != null && lp === cid) return j;
      }
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function buildLogisticsViewRfqPath(companyId) {
  const m = getSubmissionMetaForProvider(companyId);
  return buildLogisticsViewRfqPathFromIds(companyId, m?.id, m?.rfqReferenceNumber, "providers");
}

/**
 * Build view URL when id + reference come from API (logged-in) or session.
 * @param {'sent'|'providers'|'logistics-inbox'|undefined} [fromSource] — `sent` / `providers` / `logistics-inbox` set `from` for back navigation.
 */
export function buildLogisticsViewRfqPathFromIds(companyId, id, rfqReferenceNumber, fromSource, rfqKind) {
  if (id == null || rfqReferenceNumber == null || String(rfqReferenceNumber).trim() === '') return null;
  const q = new URLSearchParams({
    id: String(id),
    ref: String(rfqReferenceNumber).trim(),
  });
  if (companyId != null && Number.isFinite(Number(companyId)) && Number(companyId) > 0) {
    q.set('companyId', String(companyId));
  }
  const kind = rfqKind != null ? String(rfqKind).trim().toLowerCase() : '';
  if (kind === 'business-relocation' || kind === 'exhibition-logistics') {
    q.set('kind', kind);
  }
  if (fromSource === 'sent') {
    q.set('from', 'sent');
  } else if (fromSource === 'providers') {
    q.set('from', 'providers');
  } else if (fromSource === 'logistics-inbox') {
    q.set('from', 'logistics-inbox');
    return `/dashboard/logistics/rfqs/view?${q.toString()}`;
  }
  return `/logistics-providers/rfq/view?${q.toString()}`;
}
